<template>
  <div>
    <neo-reset-link-sent />
  </div>
</template>
<script>
import NeoResetLinkSent from '@/components/system/Auth/ResetLinkSent'
export default {
  components: {
    NeoResetLinkSent,
  },
}
</script>
